// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
    /* tslint:disable */
    export const VERSION = {
    "dirty": true,
    "raw": "b2574a3-dirty",
    "hash": "b2574a3",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "b2574a3-dirty",
    "semverString": null,
    "version": "0.0.0",
    "last_version": "3237cf98c55ec11d06be247c2c832b224c59236d\n",
    "actual_version": "b2574a309b1669274c4289e4189e3f603af4065f\n"
};
    /* tslint:enable */
    